import styled from 'styled-components'

import { linkStyle } from '../../../styles/shared/link'

export const ALink = styled.a`
  ${linkStyle}
`
